const SERVICE_IDENTIFIER = {
  FLIGHT_PATH: Symbol('FlightPathServiceInterface'),
  CONTAINER: Symbol('container'),
  FLIGHT_PATH_ADMIN: Symbol('FlightPathAdminServiceInterface'),
  FLIGHT_PATH_PRECISION_AG: Symbol('FlightPathPrecisionAgServiceInterface')
};

export default SERVICE_IDENTIFIER;
